import { render, staticRenderFns } from "./Consultants.vue?vue&type=template&id=6576aab9&"
import script from "./Consultants.vue?vue&type=script&lang=js&"
export * from "./Consultants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports